<!-- 销售退货申请操作 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField" :key="formOneKey"
                                                    :rules="$common.getFormItemRules(formOneValue, sendDataInfo)"><!-- 记账单号 -->
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)" @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)"
                                                            v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"></el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- 退货申请日期 -->
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="formOneValue.isChange == 0"
                                                        :isShowLong="false"></df-date>
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                                        @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 退货原因 -->
                                                    <el-input clearable v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" :key="formOneKey"
                                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{sendDataInfo[formOneValue.entityField] ==1 ? "是" : "否" }}</span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <el-form :inline="true" size="mini">
                                        <!-- 操作 -->
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                                新增明细</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()">删除明细</el-button>
                                            <el-button type="primary" size="mini" @click="openExComponents(626556684046336, '', 'wobkemId')">提取原单</el-button>
                                            <el-button type="primary" size="mini" @click="openExComponents(629899519725577, '', 'orderId')">提取外部订单</el-button>
                                        </div>
                                        <!-- 明细 -->
                                        <el-table :key="tableKey" :data="sendDataInfo.desuRgapplyDetails" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                            @selection-change="handleSelectionChange" id="mxTable" :height="mxHeight" border style="width: 100%" size="mini">
                                            <el-table-column width="90" label="选择" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <template v-for="(formOneValue, formOneKey) in mxForm">
                                                <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                    <template slot-scope="scope">
                                                        <div v-if="dataActionBox.actionType != 2">
                                                            <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2" clearable
                                                                @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, true)"
                                                                v-model="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                                <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, true)" slot="append"
                                                                    icon="el-icon-search"></el-button>
                                                            </el-input>
                                                            <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                                                @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                                                                v-model="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                                <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)" slot="append"
                                                                    icon="el-icon-search"></el-button>
                                                            </el-input>
                                                            <!-- 生产日期 -->
                                                            <df-date :isType="true" :isShowLong="formOneValue.entityField == 'expidate' ? true : false" v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType != 2"
                                                                :isdisabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField" :class="formOneValue.entityField"
                                                                :isLongTime="formOneValue.entityField == 'expidate' ? true : false" :isNull="formOneValue.entityField == 'expidate' || formOneValue.entityField == 'prodate' ? true : false"
                                                                @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                            </df-date>
                                                            <!-- 退回数量 -->
                                                            <el-input type="number" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" @input="calculatePrice(0, scope.$index)"
                                                                v-else-if="formOneValue.entityField == 'rgadRetnumber' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model.trim="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 含税价格 -->
                                                            <el-input type="number" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" @input="calculatePrice(1, scope.$index)"
                                                                v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model.trim="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 含税成本价 -->
                                                            <el-input type="number" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" @input="calculatePrice(2, scope.$index)"
                                                                v-else-if="formOneValue.entityField == 'woadWcost' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model.trim="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <el-input type="number" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" @input="calculatePrice(2, scope.$index)"
                                                                v-else-if="formOneValue.fieldType == 'number' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model.trim="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model.trim="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <span v-else>{{sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]}}</span>
                                                        </div>
                                                        <div v-else>
                                                            <span v-if="formOneValue.fieldType == 'date'">
                                                                <span v-if="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                                    {{$common.getLocalTime(sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField])}}
                                                                </span>
                                                            </span>
                                                            <span v-else-if="formOneValue.fieldType == 'dateTime'">
                                                                <span v-if="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                                    {{$common.getLocalTime(sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField])}}
                                                                </span>
                                                            </span>
                                                            <span v-else>
                                                                {{sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]}}
                                                            </span>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                            </template>
                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <tree ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
        <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <ExtractionSchemeQc ref="extractionScheme" :ppId="ppId" :id="exId" :extractParamsData="extractParamsData" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import ExtractionSchemeQc from '../byComponents/ExtractionSchemeQc.vue'
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: 'salesInitiaReturnAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: { ExtractionSchemeQc, SearchScheme },
    data() {
        //这里存放数据
        return {
            tableKey: 1,
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                wobkemId: '',
                "desuRgapplyDetails": [],
                "coId": '',
                "coName": '',
                "rgaiAccperiod": "",
                "rgaiDismode": "",
                "payMethod": "",
                "rgaiReserves1": "",
                "rgaiReserves2": "",
                "rgaiReserves3": "",
                "rgaiReserves4": "",
                "rgaiReserves5": "",
                "rgaiReserves6": "",
                "settleMethod": "",
                salesId: "",
                salesName: "",
                "opmId": '',
                "cmId": '',
                cmName: '',
                "rgamRapdate": 0,
                "rgamRemark": "",
                "rgamReserves1": "",
                "rgamReserves2": "",
                "rgamReserves3": "",
                "rgamReserves4": "",
                "rgamReserves5": "",
                "rgamReserves6": "",
                "depId": '',
                "depName": '',
                "totalCount": 0,
                "totalMoney": 0,
                "totalNumber": 0,
                "woamId": '',
                rgamId: '',
                credit: "",
                dismode: '',
                isWms: "",
                returnReason: ''
            },
            detaislDataInfo: {},
            showTabs: '',
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            exTitle: '',//缓存提取
            exWidth: '',
            DialogExtract: false,
            ppId: 'wobkemId',
            exId: '',
            selectedDetailsIndex: 0,	//选择操作数据
            mxHeight: 0,	//明细表格高
            dictionariesDatas: [], //配送方式
            returnResonArray: [],	//退货原因
            mxForm: [],
            tabForm: [],
            footForm: [],
            sField: '', // 赋值字段
            fField: '', //焦点字段
            inputel: '', //所有input对象
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: '',
            parentSearchData: {},
            selectedRow: [], // 当前已选择行
            extractParamsData: {},
            newDayTime: "",
            newTime: "",
            stNameFlag: false,
            showDialog: false,
            dialogList: [],
        }
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.desuRgapplyDetails': {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalCount = newValue.length//
                this.sendDataInfo.totalMoney = 0
                this.sendDataInfo.totalNumber = 0
                this.newDayTime = Number(this.$common.getNewDayTime() * 1 + 86400000)
                this.newTime = new Date(new Date().toLocaleDateString()).getTime() - 1 * 24 * 3600 * 1000
                newValue.forEach((item, keys) => {

                    let a = item.rgadRetnumber//退回数量
                    let b = item.woadPnumber//原单数量
                    let c = item.returnNum//已退货数量
                    if (item.rgadRetnumber == '') {
                        item.rgadRetnumber = 0
                    } else if (a && !a.includes('.') && a.length > 1 && a.substring(0, 1) == '0') {
                        item.rgadRetnumber = a.substring(1, a.length)
                    }
                    if (item.woadPnumber == '') {
                        item.woadPnumber = 0
                    } else if (b && !b.includes('.') && b.length > 1 && b.substring(0, 1) == '0') {
                        item.woadPnumber = b.substring(1, b.length)
                    }
                    if (item.returnNum == '') {
                        item.returnNum = 0
                    } else if (c && !c.includes('.') && c.length > 2 && c.substring(0, 1) == '0') {
                        item.returnNum = c.substring(1, c.length)
                    }
                    this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(3, NP.plus(Number(this.sendDataInfo.totalNumber), Number(item.rgadRetnumber)))
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(Number(this.sendDataInfo.totalMoney), Number(item.psmoney)))
                    if (item.prodate && item.prodate.toString().substring(item.prodate.toString().length - 3) == '001' || item.expidate && item.expidate.toString().substring(item.expidate.toString().length - 3) == '001') return
                    if ((item.prodate > this.newTime) && item.prodate != '' && this.dataActionBox.actionType == 0) {
                        item.prodate = this.newTime
                        this.$refs.prodate[keys].$forceUpdate()
                        this.$message({
                            message: "生产日期不能大于今日",
                            type: "warning",
                        });
                    }
                })
                console.log(this.sendDataInfo.totalMoney, "测试");

            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        // 计算价格
        calculatePrice(cate, index, flag) {
            var info = this.sendDataInfo.desuRgapplyDetails[index];
            if (info.woadPnumber <= 0) {
                this.$message({
                    message: "请先填写原单数量",
                    type: "error",
                });
                return false;
            }
            if (info.woadPnumber < Number(info.returnNum)) {
                this.$message({
                    message: "已退货数量不能大于原单数量",
                    type: "error",
                });
                this.sendDataInfo.desuRgapplyDetails[index].returnNum = 0
                if (!flag) {
                    this.calculatePrice(cate, index, true)
                }
                return false;
            }
            if (info.woadPnumber < Number(info.rgadRetnumber)) {
                this.$message({
                    message: "退回数量不能大于原单数量",
                    type: "error",
                });
                this.sendDataInfo.desuRgapplyDetails[index].rgadRetnumber = 0
                if (!flag) {
                    this.calculatePrice(cate, index, true)
                }
                return false;
            }
            if (info.woadPnumber < Number(info.returnNum) + Number(info.rgadRetnumber)) {
                this.$message({
                    message: "已退货数量与退回数量之和不能大于原单数量",
                    type: "error",
                });
                this.sendDataInfo.desuRgapplyDetails[index].rgadRetnumber = 0
                if (!flag) {
                    this.calculatePrice(cate, index, true)
                }
                return false;
            }
            switch (cate) {
                case 0:// 获取当前项
                    const currentItem = this.sendDataInfo.desuRgapplyDetails[index];
                    // 获取退货数量
                    const returnNumber = Number(info.rgadRetnumber);

                    // 计算各项金额
                    const calculations = {
                        psmoney: NP.times(Number(info.psprice), returnNumber),
                        costMoney: NP.times(Number(info.woadWcost), returnNumber),
                        money: NP.times(currentItem.price, returnNumber),
                        costAmount: NP.times(currentItem.costPrice, returnNumber)
                    };
                    // 更新当前项的金额信息（保留3位小数）
                    Object.keys(calculations).forEach(key => {
                        currentItem[key] = this.$common.getDecimalInfo(3, calculations[key]);
                    });

                    break;
                //计算含税金额=含税价格*退回数量
                case 1://psmoney:含税金额 psprice:含税价格 rgadRetnumber:退回数量 price:单价 outRate:销项税率 money:金额
                    //含税金额=含税价格*退回数量
                    this.sendDataInfo.desuRgapplyDetails[index].psmoney = this.$common.getDecimalInfo(
                        3, NP.times(Number(info.psprice), Number(info.rgadRetnumber))
                    )
                    // 计算金额 含税金额/(税率/100+1)
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.desuRgapplyDetails[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)));
                    this.sendDataInfo.desuRgapplyDetails[index].money = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    this.sendDataInfo.desuRgapplyDetails[index].price = info.rgadRetnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.rgadRetnumber));
                    break;
                //计算含税成本金额=含税成本价*退回数量
                case 2://costMoney:含税成本金额   woadWcost:含税成本价  rgadRetnumber:退回数量 costPrice:成本价 inRate:进项税率 costAmount:成本金额
                    //含税成本金额=含税成本价*退回数量
                    this.sendDataInfo.desuRgapplyDetails[index].costMoney = this.$common.getDecimalInfo(
                        3, NP.times(Number(info.woadWcost), Number(info.rgadRetnumber))
                    )
                    // 计算成本金额
                    //成本金额=含税成本金额/((税率/100)+1)
                    this.sendDataInfo.desuRgapplyDetails[index].costAmount = this.$common.getDecimalInfo(
                        3,
                        NP.divide(
                            this.sendDataInfo.desuRgapplyDetails[index].costMoney,
                            NP.plus(NP.divide(info.inRate, 100), 1)
                        )
                    );
                    // 计算成本价格
                    //成本价=成本金额/退回数量
                    this.sendDataInfo.desuRgapplyDetails[index].costPrice = this.$common.getDecimalInfo(
                        2,
                        NP.divide(
                            this.sendDataInfo.desuRgapplyDetails[index].costAmount,
                            Number(info.rgadRetnumber)
                        )
                    );

                    break;

                default:
                    break;
            }

            var psmoney = this.sendDataInfo.desuRgapplyDetails[index].psmoney
            var costMoney = this.sendDataInfo.desuRgapplyDetails[index].costMoney
            this.sendDataInfo.desuRgapplyDetails[index].gross = this.$common.getDecimalInfo(3, NP.minus(psmoney, costMoney));
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, flag) {
            setTimeout(() => {
                this.showDialog = false;
            }, 16.7);
            this.DialogVisible = true;
            removeEventListener('keyup', this.keyUp)
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            if (flag) {
                this.stNameFlag = true
                if (type == 'bgiRegistno') {
                    this.parentSearchData.bgmId = this.sendDataInfo.desuRgapplyDetails[this.seIndex].bgmId
                } else if (type == 'puOpmName') {
                    this.parentSearchData.opmBuyer = 1
                    this.parentSearchData.opmSalesperson = ""
                }
                this.parentSearchData[type] = this.sendDataInfo.desuRgapplyDetails[this.seIndex][type]
            } else {
                this.stNameFlag = false
                if (type == "salesName") {
                    this.parentSearchData.cmId = this.sendDataInfo.cmId;
                } else if (type == 'opmName') {
                    this.parentSearchData.opmSalesperson = 1
                }
                this.parentSearchData[type] = this.sendDataInfo[type]
            }

        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener('keyup', this.keyUp)//创建监听键盘事件
                const numberList = this.mxForm.filter(item => item.fieldType == 'number').map(item => item.entityField)
                if (this.seType == 'bgmName') {
                    for (const key in this.detaislDataInfo) {
                        const index = numberList.findIndex(items => items == key)
                        if (index != -1 && !val[key]) {
                            this.$set(this.sendDataInfo.desuRgapplyDetails[this.seIndex], key, 0)
                        } else {
                            this.$set(this.sendDataInfo.desuRgapplyDetails[this.seIndex], key, val[key] ? val[key] : '')
                        }
                    }
                    this.tableNextFocus(this.fField, this.seIndex)
                } else if (this.seType == 'bgiRegistno' || this.seType == 'smName' || this.seType == 'puOpmName' || this.seType == 'stName') {
                    if (this.stNameFlag) {
                        this.paramValue1(val)
                    } else {
                        this.paramValue(val)
                    }
                } else if (this.seType == 'cmName') {
                    this.showDialog = false;
                    let cmNameFlag = -1;
                    //销售单位
                    this.$http.checkCustomerSale({
                        //校验单位
                        formId: this.formDataList[0].jciId, //表单ID
                        unitId: val.cmId, //单位ID
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                cmNameFlag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (cmNameFlag == -1) {
                                this.parentSearchData.cmId = val.cmId;
                                this.sendDataInfo.cmId = val.cmId;
                                this.sendDataInfo.cmName = val.cmName;
                                this.$http.queryDefaultSales({
                                    ids: [val.cmId]
                                }).then((res) => {
                                    if (res && res.status == 200) {
                                        var valObj = {
                                            ...val,
                                            ...res.result,
                                        }
                                        if (valObj.salesName && valObj.salesId && this.sField.indexOf('salesName') != -1 && this.sField.indexOf('salesId') != -1) {
                                            //对方业务员
                                            this.$http.checkSalesSale({
                                                //校验对方业务员
                                                formId: this.formDataList[0].jciId, //表单ID
                                                salesId: valObj.salesId, //业务员ID
                                            }).then((res) => {
                                                if (res && res.status == 200) {
                                                    let flag = -1;
                                                    if (res.result != null && res.result.length > 0) {
                                                        res.result.forEach(item => {
                                                            this.dialogList.push(item)
                                                        })
                                                        flag = this.dialogList.findIndex((item) => item.level == 0);
                                                        this.showDialog = true;
                                                    }
                                                    if (flag == -1) {
                                                        this.sendDataInfo.salesName = valObj.salesName;
                                                        this.sendDataInfo.salesId = valObj.salesId;
                                                    } else {
                                                        this.showDialog = true;
                                                    }
                                                } else {
                                                    this.lineMessageBox(res);
                                                }
                                            }).catch((rej) => {
                                                this.lineMessageBox(rej);
                                            });
                                        } else {
                                            this.paramValue(valObj)
                                        }
                                    } else {
                                        this.paramValue(val)
                                    }
                                }).catch((rej) => {
                                    this.lineMessageBox(rej);
                                });
                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.parentSearchData.cmId = "";
                            this.clearValue();
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.parentSearchData.cmId = "";
                        this.clearValue();
                    });
                } else {
                    if (this.stNameFlag) {
                        this.paramValue1(val)
                    } else {
                        this.paramValue(val)
                    }
                }
            }
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            if (this.seType == 'opmName') {
                this.sendDataInfo.opmId = val.opmId
            }
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        // 赋值字段
        paramValue1(val) {
            console.log(val);
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo.desuRgapplyDetails[this.seIndex][item] = val[item]
            })
            this.tableKey = this.tableKey == 1 ? 0 : 1
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableNextFocus(this.fField, this.seIndex)
                }, 16.4)
            })
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.desuRgapplyDetails.length > 0) {
                    this.tableNextFocus('rgadRetnumber', this.selectedDetailsIndex)
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    })
                }
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }

            this.inputel[aindex].focus()
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "prodate") {
                let ine = document
                    .getElementsByClassName("prodate")[index].getElementsByTagName("input")[0];
                ine.focus();
                return;
            } else if (field == "expidate") {
                let ine = document
                    .getElementsByClassName("expidate")[index].getElementsByTagName("input")[0];
                ine.focus();
                return;
            }
            if (field == 'keydown') {
                this.addDetail('sendDataInfo')
                if (this.sendDataInfo.desuRgapplyDetails[index + 1] != undefined) {
                    // this.$refs['bgmName'][index + 1].focus()
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    })
                    return
                }
                return
            }
            this.$refs[field][index].focus()
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 新增明细
                e.preventDefault();
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.desuRgapplyDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.desuRgapplyDetails.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.desuRgapplyDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.desuRgapplyDetails.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        // 触发提取方案
        openExComponents(e, index, type) {
            this.exId = e;
            this.seType == type
            this.seIndex = index
            if (e == 629899519725577) {
                this.ppId = "orderId"
            } else if (e == 626556684046336) {
                this.ppId = "wobkemId"
            }
            this.DialogExtract = true;
            this.extractParamsData[type] = this.sendDataInfo[type]
            removeEventListener('keyup', this.keyUp)
        },

        // 获取 提取单数据
        async getExData(res) {
            let val = JSON.parse(JSON.stringify(res))
            console.log('提取', val);
            if (val != "" || val != undefined) {
                this.sendDataInfo.desuRgapplyDetails = []
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        for (const key1 in val.arrlistbychen) {
                            this.$set(this.sendDataInfo.desuRgapplyDetails, key1, val.arrlistbychen[key1])
                            for (const key2 in val.arrlistbychen[key1]) {
                                this.$set(this.sendDataInfo.desuRgapplyDetails[key1], key2, val.arrlistbychen[key1][key2])
                            }
                        }
                        this.sendDataInfo.desuRgapplyDetails.forEach(item => {
                            this.$set(item, 'money', 0)
                            this.$set(item, 'psmoney', 0)
                            this.$set(item, 'rgadRecostMoneytnumber', 0)
                            this.$set(item, 'gross', 0)
                            this.$set(item, 'costAmount', 0)
                        })
                    } else {
                        this.sendDataInfo.wobkemId = val.wobkemId
                        this.sendDataInfo.coName = val.coName
                        this.sendDataInfo.cmName = val.cmName
                        this.sendDataInfo.cmId = val.cmId
                        this.sendDataInfo.coId = val.coId
                        this.sendDataInfo.rgamRemark = val.rgamRemark
                        this.sendDataInfo.totalMoney = 0
                        this.sendDataInfo.totalNumber = 0
                        this.sendDataInfo.totalCount = 0
                        if (this.exId == 629899519725577) {
                            this.sendDataInfo[key] = val[key]
                        }
                    }
                }
                if (!val.salesName || !val.salesId || !val.recName || !val.recId) {
                    this.$http.queryDefaultSales({
                        ids: [val.cmId]
                    }).then((res) => {
                        if (res && res.status == 200) {
                            for (const key in res.result) {
                                if (!this.sendDataInfo[key]) {
                                    this.sendDataInfo[key] = res.result[key];
                                }
                            }
                        }
                    })
                }
                this.$nextTick(() => {
                    this.detailListener()
                    this.selectedDetailsIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    this.nextFocus(this.seIndex)
                })
                this.sendDataInfo.accountTime = new Date().getTime()
            } else {
                this.$message({
                    message: '未拿到数据',
                    type: 'error'
                })
            }
            this.DialogExtract = false
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach(item => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.depId = item.depId
                    this.sendDataInfo.depName = item.depName
                }
            })
            console.log(data)
        },
        //确认新增
        async sendDataAction(formName) {
            let flag = false
            this.$refs[formName].validate((valid) => {
                if (valid) {

                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    flag = true
                    return false;
                }
            })
            if (flag) return false;
            if (this.sendDataInfo.desuRgapplyDetails.length < 1) {
                this.$message({
                    message: '请添加退回明细',
                    type: 'error'
                });
                return false
            }
            for (let i = 0; i < this.sendDataInfo.desuRgapplyDetails.length; i++) {
                const element = this.sendDataInfo.desuRgapplyDetails[i]
                if (!element.rgadRetnumber || Number(element.rgadRetnumber) <= 0 || Number(element.rgadRetnumber) > Number(element.woadPnumber)) {
                    this.$message({
                        message: '请填写合理的退回数量',
                        type: 'error'
                    });
                    return false
                }
            }

            var flagNum = false
            var flag1 = false
            var flagPsmoney = false
            var flagMoney = false
            var flagPrice = false
            var indexNum = 0
            var indexNum1 = 0
            var indexNum2 = 0
            var indexNum3 = 0
            var indexNum4 = 0
            this.sendDataInfo.desuRgapplyDetails.forEach((item, index) => {
                if ((item.rgadRetnumber == "" || item.rgadRetnumber == null || item.rgadRetnumber <= 0) && !flagNum) {
                    indexNum = index
                    flagNum = true
                }
                if ((item.psprice == "" || item.psprice == null || item.psprice <= 0) && (item.psmoney == "" || item.psmoney == null || item.psmoney <= 0) && (item.price == "" || item.price == null || item.price <= 0) && (item.money == "" || item.money == null || item.money <= 0)) {

                } else if (item.psprice > 0 && item.psmoney > 0 && item.price > 0 && item.money > 0) {
                    if (this.$common.getDecimalInfo(3, (item.psprice * item.rgadRetnumber)) != item.psmoney && !flagPsmoney) {
                        indexNum1 = index
                        flagPsmoney = true
                    }
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(item.psmoney, NP.plus(NP.divide((item.outRate || 0), 100), 1)));
                    if (this.$common.getDecimalInfo(3, midmoney) != item.money && !flagMoney) {
                        indexNum2 = index
                        flagMoney = true
                    }
                    var price = this.$common.getDecimalInfo(2, NP.divide(midmoney, item.rgadRetnumber))
                    if (price != item.price && !flagPrice) {
                        indexNum3 = index
                        flagPrice = true
                    }
                } else if (!flag1) {
                    indexNum4 = index
                    flag1 = true
                }
            })
            if (flagNum) {
                return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum].bgmName}数量不能为空或为零！`)
            }
            if (flagPsmoney) {
                return this.$message.error(`第${indexNum1 + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum1].bgmName}含税金额计算规则不符！`)
            }
            if (flagMoney) {
                return this.$message.error(`第${indexNum2 + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum2].bgmName}金额计算规则不符！`)
            }
            if (flagPrice) {
                return this.$message.error(`第${indexNum3 + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum3].bgmName}价格计算规则不符！`)
            }
            if (flag1) {
                return this.$message.error(`第${indexNum4 + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum4].bgmName}（含税价格、含税金额、价格、金额）有为零的请检查！`)
            }

            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            var responseData
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.addInitReturnList(sendData)
            } else {
                responseData = await this.$http.editInitReturnList(sendData)
            }
            if (responseData.status == 200) {
                this.init()
                this.$emit('drawerCancel')
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //新增明细
        addDetail(sendDataInfo) {
            var flag = false
            if (this.sendDataInfo.desuRgapplyDetails.length > 0) {
                this.sendDataInfo.desuRgapplyDetails.forEach(item => {
                    if (item.bgmId == "") {
                        flag = true
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                })
            }
            if (flag) {
                return
            }
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.desuRgapplyDetails.push({})
                    var index = this.sendDataInfo.desuRgapplyDetails.length - 1
                    for (const key in this.detaislDataInfo) {
                        this.$set(this.sendDataInfo.desuRgapplyDetails[index], key, this.detaislDataInfo[key])
                    }
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(this.sendDataInfo.desuRgapplyDetails.length - 1)
                        this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    })
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        //删除明细
        deleteDetails() {
            if (this.sendDataInfo.desuRgapplyDetails.length < 1) {
                this.$message({
                    message: '请先添加明细',
                    type: 'error'
                });
                return false
            }
            this.sendDataInfo.desuRgapplyDetails.splice(this.selectedDetailsIndex, 1)
            this.$nextTick(() => {
                if (this.sendDataInfo.desuRgapplyDetails.length > 1) {
                    this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                    this.tableNextFocus('rgadRetnumber', this.selectedDetailsIndex)
                } else {
                    this.selectedDetailsIndex = 0
                }
                let refsElTable = this.$refs.mxTableRef
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
            })
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform
            arr.forEach(item => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this.sendDataInfo[item.entityField] = item.defaultValue
                }
            })
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
        },
        //初始
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'desuRgapplySupInfo') {
                    this.sendDataInfo[key]
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = ''
                    }
                } else {
                    this.sendDataInfo[key] = ''
                }
            }
            this.sendDataInfo.desuRgapplyDetails = []
            this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalCount = 0
        },
        //取消
        initActionBox(formName) {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$common.delOrderInfo(this.sendDataInfo.wobkemId)
                this.$emit('drawerCancel')
                this.init()
                this.$refs[formName].resetFields();
            }).catch(() => { });
        },

        // 提取数据
        async extractData(data) {
            if (data.length >= 1) {
                var sendData = []
                data.forEach(items => {
                    sendData.push(items.wobkedId)
                })
                let responseData = await this.$http.extractSalesOrder({ ids: sendData })
                if (responseData.status == 200) {
                    this.sendDataInfo = responseData.result
                    this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }

        },

        async isShowData(name, value) {
            console.log(name)
            switch (name) {
                case 'cmId':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.cmId = dataInfo.cmId
                        this.sendDataInfo.cmName = dataInfo.cmName

                    }
                    console.log(dataInfo)
                    break;

                case 'cargoOwner':
                    var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
                    console.log(dataInfo)
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.desuRgapplySupInfo.coId = dataInfo.coId
                        this.sendDataInfo.desuRgapplySupInfo.coName = dataInfo.coName
                    }

                    break;
            }
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.init()
            this.getSpecialUser()
            this.getPartDictionariesData()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
                this.initDefaultValue()
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.rgamId)
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })
        },

        //明细监听函数
        detailListener() {
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalCount = 0
            this.sendDataInfo.desuRgapplyDetails.forEach((item, keys) => {

                if (!item.rgadRetnumber || item.rgadRetnumber <= 0) {
                    this.sendDataInfo.desuRgapplyDetails[keys].rgadRetnumber = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].money = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].psmoney = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].costMoney = 0	//成本金额
                    this.sendDataInfo.desuRgapplyDetails[keys].gross = 0	//毛利
                    this.sendDataInfo.desuRgapplyDetails[keys].costAmount = 0	//成本金额
                    return false
                }
                if (item.woadPnumber - item.returnNum < item.rgadRetnumber) {
                    this.$message({
                        message: '退货数量+已退数量不得大于原单数量',
                        type: 'error'
                    })
                    this.sendDataInfo.desuRgapplyDetails[keys].rgadRetnumber = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].money = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].psmoney = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].costMoney = 0	//成本金额
                    this.sendDataInfo.desuRgapplyDetails[keys].gross = 0	//毛利
                    return false
                }
                if (item.rgadRetnumber > item.woadPnumber) {
                    this.$message({
                        message: '退货数量不得大于原单数量',
                        type: 'error'
                    })
                    this.sendDataInfo.desuRgapplyDetails[keys].rgadRetnumber = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].money = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].psmoney = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].costMoney = 0	//成本金额
                    this.sendDataInfo.desuRgapplyDetails[keys].gross = 0	//毛利
                    return false
                }
                // 计算成本金额 成本价格*数量
                this.sendDataInfo.desuRgapplyDetails[keys].costAmount =
                    this.$common.getDecimalInfo(3, NP.times(item.costPrice || 0, item.rgadRetnumber || 0));

                var money = this.$common.getDecimalInfo(3, NP.times(item.price || 0, item.rgadRetnumber || 0))
                var psMoney = this.$common.getDecimalInfo(3, NP.times(item.psprice || 0, item.rgadRetnumber || 0))
                this.sendDataInfo.desuRgapplyDetails[keys].money = money
                this.sendDataInfo.desuRgapplyDetails[keys].psmoney = psMoney

                this.sendDataInfo.desuRgapplyDetails[keys].costMoney = this.$common.getDecimalInfo(3, NP.times(item.woadWcost || 0, item.rgadRetnumber || 0))	//成本金额
                this.sendDataInfo.desuRgapplyDetails[keys].gross = this.$common.getDecimalInfo(3, NP.minus(NP.times(item.psprice || 0, item.rgadRetnumber || 0), NP.times(item.woadWcost || 0, item.rgadRetnumber || 0)))	//毛利
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney || 0, psMoney || 0))
                this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber || 0, item.rgadRetnumber || 0))
            })
            this.sendDataInfo.desuRgapplyDetails.splice(1, 0)
        },

        // 获取供货员
        async getSpecialUser() {

            let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 })
            if (responseData.status == 200) {
                this.userOneList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({ ids: [20, 21] })
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //获取配送方式
        async distributionModes(id, own) {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [id],
            });
            if (responseData.status == 200) {
                this[own] = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //json字符串转换成数组
        toArray(str) {
            str && str.replace(/\\/g, '')
            try {
                var arr = JSON.parse(str);
                if (arr && Array.isArray(arr)) {
                    // console.log(arr)
                    return arr;
                } else {
                    return [];
                }
            } catch (e) {
                return [];
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                    this.mxForm.forEach(item1 => {
                        if (item1.fieldType == 'number') {
                            this.$set(this.detaislDataInfo, item1.entityField, 0)
                        } else if (item1.fieldType == 'search' && item1.setField) {
                            var arr = item1.setField.split(',')
                            arr.forEach(item2 => {
                                this.$set(this.detaislDataInfo, item2, "")
                            })
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "")
                        }
                    })
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            var arr = [{ entityField: "desuRgapplyDetails" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "rgamRapdate", this.$moment().valueOf())
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.distributionModes(37, 'dictionariesDatas')	//配送
        this.distributionModes(40, 'returnResonArray')	//退货原因
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        }
        addEventListener('keyup', this.keyUp)//创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-drawer {
    outline: none;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>